export default __webpack_public_path__ + "static/media/10-BAPA-Food-Expo-With-Industry-partners.5fedd91a.jpg";